import React from 'react';
import 'react-dom';
import '../../_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import '../../index-930c2100.js';
import '../../hooks/useActivify.js';
import '../../index-efb29065.js';
import '../../key_codes-a5a2b85e.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '../../style-inject.es-1f59c1d0.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import '../box.js';
import { g as getObjectValue } from '../../util-cc00ee1d.js';
import '../../index.esm-f8e9e79f.js';
import '@styled-system/grid';
import '@styled-system/background';
import { I as IconWrapper } from '../../IconWrapper-eb05d1ed.js';

var EntityV2 = function EntityV2(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.1845 2.04705C12.07 1.98432 11.93 1.98432 11.8155 2.04705L3.19046 6.77432C3.07279 6.83883 3 6.95981 3 7.0909V16.8182C3 16.9482 3.07162 17.0684 3.1878 17.1333L11.8128 21.9515C11.9277 22.0156 12.0691 22.0162 12.1845 21.9529L20.8095 17.2257C20.9272 17.1612 21 17.0402 21 16.9091V7.0909C21 6.95981 20.9272 6.83883 20.8095 6.77432L12.1845 2.04705ZM7.7511 9.9552L3.75 7.72007V16.1778L7.74848 13.8646C7.45684 13.272 7.29364 12.6086 7.29364 11.9091C7.29364 11.2094 7.458 10.5469 7.7511 9.9552ZM11.625 21.0072L4.11641 16.8127L8.12475 14.4938C8.907 15.5892 10.1737 16.3359 11.625 16.4416V21.0072ZM12.375 21.0131V16.4387C13.8091 16.323 15.0596 15.5811 15.8353 14.4969L19.8852 16.8969L12.375 21.0131ZM20.25 16.2607L16.2121 13.8679C16.5048 13.2744 16.6686 12.6099 16.6686 11.9091C16.6686 11.2152 16.5096 10.5573 16.2247 9.96869L20.25 7.72007V16.2607ZM19.8684 7.09392L15.8527 9.33719C15.0796 8.23938 13.8233 7.48919 12.375 7.37796V2.98686L19.8684 7.09392ZM11.625 2.98686V7.37796C10.1805 7.48879 8.91349 8.23399 8.12899 9.32694L4.1316 7.09392L11.625 2.98686Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
EntityV2.propTypes = {
  iconColor: PropTypes.string
};
EntityV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EntityV2",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var EntityV2$1 = withTheme(EntityV2);

export default EntityV2$1;
